import { useState, useCallback } from "react";

export default function useSelectedNode() {
  const [selectedNode, setSelectedNode] = useState(null);

  const onNodeClick = useCallback((event, node) => {
    if (node.type === "exitNode") {
      return;
    }
    setSelectedNode({ ...node });
  }, []);

  const onPaneClick = useCallback(() => {
    setSelectedNode(null);
  }, []);

  return {
    selectedNode,
    setSelectedNode,
    onNodeClick,
    onPaneClick,
  };
}
